// Map question text and survey question text should be translated within appConfig.js
// Do not edit text within curly brackets, ie: {abc}
// Format: "<ComponentName>.<Description>": "<Text>"

module.exports = ({
    "polyline": "Percorso",
    "icon": "Punti di interesse",
    "polygon": "Forma",

    // (optional) {branch_name} can be used to display the branch display name in the document title
    "DocumentTitle.map_page": "{branch_name} | Map",
    "DocumentTitle.error_page": "{branch_name} | Error",
    "DocumentTitle.end_page": "{branch_name} | Finish",
    "DocumentTitle.intro_modal": "{branch_name} | Intro",
    "DocumentTitle.info_modal": "{branch_name} | Info",
    "DocumentTitle.survey_modal": "{branch_name} | Survey",

    "Landing.header": "Welcome!",
    "Landing.main_copy": "Use this tool to tell us how you interact with your neighborhood and help us understand considerations for this place.",
    "Landing.back_to_map": "Back to map",
    "Landing.start_answering": "Inizia",
    "Landing.data.header": "Utilizzo dei dati",
    "Landing.data.copy": "We will protect your privacy and all data will be used only internally.",
    "Landing.help.header": "Istruzioni",
    "Landing.help.copy": "On the map you can draw points, lines or areas to describe your place. You can search for a place, and the map can be panned, zoomed in and out, and toggled between roadmap and satellite.",
    "Landing.feedback": "Inviaci i tuoi commenti e opinioni",

    "MapContainer.continue": "Continuar",
    "MapContainer.back_button": "Torna alla mappa",
    "MapContainer.info_button": "Istruzioni",
    "MapContainer.finish_button": "Mappe completate",
    "MapContainer.submit": "Submit",
    "MapContainer.mapButtonInfo": "Eseguire lo zoom sulla posizione",
    "MapContainer.roadmap": "Roadmap",
    "MapContainer.satellite": "Satellite",


    "CancelButton.text": "Cancel",

    "IconDrawer.expand_drawer": "Expand",
    "IconDrawer.instructions": "Draw",

    "LayerToggle.roadmap": "Roadmap",
    "LayerToggle.satellite": "Satellite",

    "ConfirmationPopup.done": "Done",
    "ConfirmationPopup.cancel": "Cancel",

    "PolygonDraw.default_message": "Click anywhere to start drawing your shape.",
    "PolygonDraw.alternative_message": "Draw points to resize your shape.",

    "PolylineDraw.default_message": "Click anywhere to start drawing your line.",
    "PolylineDraw.alternative_message": "Draw points to resize your line.",

    "IconDrop.default_message": "Click anywhere to add an icon.",
    "IconDrop.alternative_message": "Drag the icon to change its position.",

    "EditModal.delete": "Elimina",
    "EditModal.save": "Salva",
    "EditModal.cancel": "Annulla",
    "EditModal.textarea_placeholder": "Ci dica di più o fai clic su salva.",
    "EditModal.addTitle": "Aggiungi il tuo {icon_type}",
    "EditModal.editTitle": "Edit your {icon_type}",
    "EditModal.reactionTitle": "Tell us about your experience.",
    "EditModal.starRatingTitle": "Come valuteresti la tua esperienza qui?",
    "EditModal.commentTitle": "Qualche altro pensiero?",
    "EditModal.deleteConfirmation": "Are you sure?",
    "EditModal.deleteConfirmationText": "Removing this {icon_type} cannot be undone.",

    "SearchBox.placeholder": "Search for location",

    "Survey.submitting": "Submitting...",

    "EndLanding.header": "Grazie",
    "EndLanding.copy": "Ending copy",
    "EndLanding.take_again": "Share more insights about your place -- start again!",
});



// WEBPACK FOOTER //
// ./src/locales/it-IT.js